export default __webpack_public_path__ + "static/media/Create-documentation.7f583e42.md";